var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-area"},[_c('div',{staticClass:"list-area__label"},[_vm._t("label")],2),_c('div',{staticClass:"list-area__body"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }